export default "__VITE_ASSET__rU4jC5e6__"